var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBluetooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.26 8.51-2.33-1.87v4l2.33-2.13z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm8.94 13.49c-.01.41-.2.8-.53 1.08l-2.42 2.02c-.42.35-.8.45-1.09.45-.23 0-.41-.06-.51-.11-.23-.11-.77-.47-.77-1.45v-3.42l-2.92 2.68c-.3.28-.78.26-1.06-.05a.746.746 0 0 1 .05-1.06l3.93-3.6v-.08L7.49 8.38a.755.755 0 0 1-.04-1.06c.28-.3.76-.33 1.06-.05l2.92 2.68V6.53c0-.98.54-1.34.77-1.45.23-.11.85-.29 1.6.34l2.42 2.02c.33.27.52.67.53 1.08.01.41-.16.81-.48 1.1L13.67 12l2.6 2.39c.31.29.49.69.48 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.26 15.41-2.33-2.11v4.06l2.33-1.95z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBluetooth);
export default __webpack_public_path__ + "static/media/vuesax-bold-bluetooth.d357eb28730f47e8f9c615993c7154cf.svg";
export { ForwardRef as ReactComponent };